import moment from 'moment';
import { displayPercent, displayShortDate } from '../../utils/Format/Format';

export const TopTenHoldingsBondUtil = (selectedPeriod, selectedDate) => (
    gqlResult
) => {
    if (!gqlResult) return null;

    const {
        name,
        inceptionDate,
        broadAssetClass,
        selectiveDisclosures
    } = gqlResult.mutualFund;

    const { quarterly = {}, monthly = [] } = selectiveDisclosures || {};

    let effectiveDates = monthly.map((ele) => ({
        value: ele.asOfDate,
        label: displayShortDate(ele.asOfDate),
        hasData: ele.individualHoldings && ele.individualHoldings.length > 0
    }));

    const fundAgeInMonth = moment().diff(inceptionDate, 'months');
    if (fundAgeInMonth <= 1) {
        effectiveDates = effectiveDates.slice(0, 1);
    }

    let asOfDate = !selectedDate
        ? monthly[0] && monthly[0].asOfDate
        : selectedDate;
    asOfDate = selectedPeriod === 'month' ? asOfDate : quarterly.asOfDate;

    let [selectiveDisclosure = {}] = monthly.filter(
        (ele) => displayShortDate(ele.asOfDate) === displayShortDate(asOfDate)
    );

    // pick non-empty monthly data (shouldn't really happen)
    if (
        selectedPeriod === 'month' &&
        (!selectiveDisclosure.individualHoldings ||
            selectiveDisclosure.individualHoldings.length < 1)
    ) {
        [selectiveDisclosure] = monthly.filter(
            (ele) => ele.individualHoldings && ele.individualHoldings.length > 0
        );
        ({ asOfDate = '' } = !selectiveDisclosure || selectiveDisclosure);
    }

    /* eslint-disable */
    // TODO - prettier is conflicing with eslint, throws an error after running prettier or manually matching to eslint spec
    const data =
        selectiveDisclosure && selectiveDisclosure.individualHoldings.length
            ? selectiveDisclosure.individualHoldings.map((ele) => {
                  const displayValues =
                      Boolean(ele.holdingCouponRate) &&
                      Boolean(ele.holdingMaturityDate);
                  return {
                      label: ele.name,
                      values: [
                          {
                              val1: displayValues
                                  ? displayPercent(ele.holdingCouponRate)
                                  : 'N/A'
                          },
                          {
                              val2: displayValues
                                  ? displayShortDate(ele.holdingMaturityDate)
                                  : 'N/A'
                          }
                      ]
                  };
              })
            : [];

    const buttonList = [
        { label: 'Monthly', val: 'month', disabled: false },
        {
            label: 'Quarterly',
            val: 'quarter',
            disabled:
                !quarterly ||
                !Object.keys(quarterly).length ||
                quarterly.rankings < 1
        }
    ];

    return {
        asOfDate,
        data,
        inceptionDate,
        broadAssetClass,
        percentHoldings: displayPercent(
            !selectiveDisclosure ||
                selectiveDisclosure.top10CalculatedPercentage
        ),
        name,
        totalHoldings: selectiveDisclosure && selectiveDisclosure.totalHoldings,
        effectiveDates,
        buttonList
    };
};
